<h2>REST Test</h2>

<p>Click an option and check browser console for results.</p>

<div>
  <button type="button" (click)="runThingsToBeCollected()">
    thingsToBeCollected
  </button>
</div>

<div>
  <button type="button" (click)="runGetCollectorZones()">
    getCollectorZones
  </button>
</div>

<div>
  <button type="button" (click)="runGetCollectorBinsToCollect()">
    getCollectorBinsToCollect
  </button>
</div>

<div>
  <button type="button" (click)="runGetCollectorOptimizedRoutes()">
    getCollectorOptimizedRoutes
  </button>
</div>
